import React from 'react';
import { Section } from 'jbc-front/components/Form';
import { getOptionLabel, recordDisplay } from 'src/utils/Utils';
import tableStyles from 'src/features/Employees/styles/GeneralTableInfo.scss';
import styles from './BanksSectionShow.scss';
import { useTranslation } from 'react-i18next';
import DefaultValue from './DefaultValue';

const BankItemShow = ({ bank, index, depositTypes }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.sectionWrap}>
      <Section title={t('features.Employees.components.BankItemSection.bank_account_information')+` ${index + 1}`}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            {bank.isUseToTransfer && (
              <tr>
                <th>{t('features.Clients.components.BanksSectionShow.Use_as_a_transfer_account')}</th>
                <td />
              </tr>
            )}
            <tr>
              <th>{t('features.Clients.components.BanksSectionShow.Bank')}：</th>
              <td>{recordDisplay(bank.bankName)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.bank_code')}：</th>
              <td>{recordDisplay(bank.bankCode)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.bank_short_name')}：</th>
              <td>{recordDisplay(bank.bankShortName)}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BanksSectionShow.Branch')}：</th>
              <td>{recordDisplay(bank.branchName)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.branch_code')}：</th>
              <td>{recordDisplay(bank.branchCode)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.account_type')}：</th>
              <td>{recordDisplay(getOptionLabel(bank.depositType)(depositTypes))}</td>
            </tr>
            <tr>
              <th>{t('features.EmployeeBonus.ShowBonusFbDataPage.bank_account_number')}：</th>
              <td>{recordDisplay(bank.accountNumber)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.account_holder_name')}：</th>
              <td>{recordDisplay(bank.accountHolder)}</td>
            </tr>
            {/*
            <tr>
              <th>
                {t('features.Clients.components.BanksSectionShow.company_code')}<br />{t('features.Clients.components.BanksSectionShow.for_payroll_transfer')}：
              </th>
              <td>{bank.consignorCodePay}</td>
            </tr>
            <tr>
              <th>
                {t('features.Clients.components.BanksSectionShow.company_code')}<br />{t('features.Clients.components.BanksSectionShow.for_general_transfer')}：
              </th>
              <td>{bank.consignorCodeTotal}</td>
            </tr>
            <tr>
              <th>
                会社コード<br />（住民税振込用）：
              </th>
              <td>{bank.consignorCodeInhabitantTax}</td>
            </tr>
            */}
          </tbody>
        </table>
      </Section>
    </div>
  )
};

const BanksSectionShow = ({ banks, depositTypes }) => {
  if (banks)
    return (
      <div>{banks.map((bank, index) => <BankItemShow {...{ bank, index, depositTypes }} key={bank.id} />)}</div>
    )
  return <DefaultValue />
}

export default BanksSectionShow;
